import { configureStore } from '@reduxjs/toolkit';
import UserSlice from './RTK/features/UserSlice';
import setPositioniSlice from './RTK/features/AdmissionSlice';
import AuthSlice from "./RTK/features/AuthSlice"
import sectionSearchSlice from "./RTK/features/SearchSectionSlice"
import setSingle_lab from "./RTK/features/Single_labSlice"
import DocTurnStatus from './RTK/features/DocIdSlice';



export const makeStore = () => {
  return configureStore({
    reducer: {
      user: UserSlice,
      admission: setPositioniSlice,
      auth_token_slice: AuthSlice,
      sectionSearchSlice: sectionSearchSlice,
      setSingle_lab,
      DocTurnStatus
    },
    devTools: true
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

